<template>
    <div class="admin-instance-page">
        <div class="nk-block-head nk-block-head-sm">
            <div class="nk-block-between align-items-start">
                <div class="nk-block-head-content admin-instance-list__intro">
                    <div class="admin-instance-list__title-row">
                        <h3 class="nk-block-title page-title mb-0">{{ trans('instance.instance') }}</h3>
                    </div>
                    <div class="nk-block-des text-soft" v-if="!instances.total">
                        <p>{{ trans('instance.module_info_description') }}</p>
                    </div>
                </div>
                <div class="nk-fmg-actions flex-shrink-0">
                    <ul class="nk-block-tools g-2 flex-wrap justify-content-end">
                        <li>
                            <a href="#" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" role="button" aria-controls="instance-filter-panel" :aria-expanded="showFilterPanel ? 'true' : 'false'" @click.prevent="showFilterPanel = !showFilterPanel" @keydown.space.prevent="showFilterPanel = !showFilterPanel">
                                <admin-icon name="sliders" aria-hidden="true"></admin-icon> <span>{{ trans('general.filter') }}</span>
                            </a>
                        </li>
                        <li v-if="hasPermission('edit-instance')" class="nk-block-tools-opt">
                            <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid" v-b-modal.modal-instance-create>
                                <admin-icon name="plus"></admin-icon> {{ trans('instance.add_new_instance') }}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        
        <transition name="fade">
            <div id="instance-filter-panel" class="card admin-instance-form-card mb-2" v-if="showFilterPanel">
                <div class="card-body">
                    <div class="admin-instance-card-head">
                        <h4 class="admin-instance-card-head__title">{{trans('general.filter')}}</h4>
                        <p class="admin-instance-card-head__hint">{{ trans('instance.instance') }}</p>
                    </div>
                    <div class="row">
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label for="">{{trans('instance.domain')}}</label>
                                <input class="form-control" name="domain" v-model="filterInstanceForm.domain">
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label for="">{{trans('instance.custom_domain')}}</label>
                                <input class="form-control" name="custom_domain" v-model="filterInstanceForm.custom_domain">
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label for="">{{trans('instance.email')}}</label>
                                <input class="form-control" name="email" v-model="filterInstanceForm.email">
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label for="">{{trans('instance.status')}}</label>
                                <select name="status" class="form-control" v-model="filterInstanceForm.status">
                                    <option value="">{{trans('general.select_one')}}</option>
                                    <option value="pending">{{trans('instance.pending')}}</option>
                                    <option value="running">{{trans('instance.running')}}</option>
                                    <option value="trial">{{trans('instance.trial')}}</option>
                                    <option value="expired">{{trans('instance.expired')}}</option>
                                    <option value="suspended">{{trans('instance.suspended')}}</option>
                                    <option value="terminated">{{trans('instance.terminated')}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <date-range-picker :start-date.sync="filterInstanceForm.start_date" :end-date.sync="filterInstanceForm.end_date" :label="trans('general.date_between')"></date-range-picker>
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label for="">{{trans('general.sort_by')}}</label>
                                <select name="order" class="form-control" v-model="filterInstanceForm.sort_by">
                                    <option value="first_name">{{ instanceTxt('instance.client', 'Client') }}</option>
                                    <option value="email">{{trans('instance.email')}}</option>
                                    <option value="created_at">{{trans('instance.created_at')}}</option>
                                    <option value="status">{{trans('instance.status')}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label for="">{{trans('general.order')}}</label>
                                <select name="order" class="form-control" v-model="filterInstanceForm.order">
                                    <option value="asc">{{trans('general.ascending')}}</option>
                                    <option value="desc">{{trans('general.descending')}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        
        <div class="admin-list-table-card mt-2" v-if="hasPermission('list-instance') && instances.total">
            <div class="table-responsive">
                <table class="table admin-data-table admin-data-table--config-list admin-data-table--instance-list mb-0">
                    <thead>
                        <tr>
                            <sortable-th field="first_name" :sort-by="filterInstanceForm.sort_by" :order="filterInstanceForm.order" @sort="sortList">{{ instanceTxt('instance.client', 'Client') }}</sortable-th>
                            <sortable-th field="status" :sort-by="filterInstanceForm.sort_by" :order="filterInstanceForm.order" @sort="sortList">{{trans('instance.status')}}</sortable-th>
                            <th>{{trans('plan.plan')}}</th>
                            <th class="admin-table-cell--instance-db">{{ instanceTxt('instance.database', 'Database') }}</th>
                            <sortable-th field="created_at" :sort-by="filterInstanceForm.sort_by" :order="filterInstanceForm.order" @sort="sortList">{{trans('instance.created_at')}}</sortable-th>
                            <th class="admin-table-actions-cell">{{trans('general.actions')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="instance in instances.data" :key="instance.id">
                            <td class="admin-table-cell--instance-client">
                                <div class="admin-instance-client">
                                    <div v-if="instanceClientPrimary(instance)" class="admin-instance-stack__primary">{{ instanceClientPrimary(instance) }}</div>
                                    <div v-if="instanceClientSchoolLine(instance)" class="admin-instance-stack__school">{{ instanceClientSchoolLine(instance) }}</div>
                                    <div v-if="instance.email && instanceClientPrimary(instance) !== instance.email" class="admin-instance-stack__muted">{{ instance.email }}</div>
                                    <p v-if="instance.status == 'pending' && instance.activation_token" class="mb-0"><small>{{ instance.activation_token }}</small></p>
                                    <div v-if="instance.phone" class="admin-instance-stack__muted">{{ instance.phone }}</div>
                                    <div v-if="instanceSchoolPortalUrl(instance)" class="admin-instance-stack__domain">
                                        <span class="admin-instance-domain-row">
                                            <a
                                                v-if="canInstanceDirectLogin(instance)"
                                                href="#"
                                                class="admin-instance-domain-link"
                                                :title="trans('instance.direct_login_school')"
                                                @click.prevent="openSchoolDirectLogin(instance)"
                                            >{{ instanceDomainDisplayLabel(instance) }}</a>
                                            <a
                                                v-else
                                                :href="instanceSchoolPortalUrl(instance)"
                                                target="_blank"
                                                rel="noopener"
                                                class="admin-instance-domain-link"
                                            >{{ instanceDomainDisplayLabel(instance) }}</a>
                                            <button
                                                type="button"
                                                class="btn btn-icon btn-sm admin-instance-domain-copy"
                                                :title="trans('instance.copy_school_url')"
                                                :aria-label="trans('instance.copy_school_url')"
                                                @click.stop="copySchoolPortalUrl(instance)"
                                            >
                                                <admin-icon name="copy" aria-hidden="true"></admin-icon>
                                            </button>
                                        </span>
                                    </div>
                                    <div v-if="instanceCustomDomainLabel(instance)" class="admin-instance-stack__muted">{{ instanceCustomDomainLabel(instance) }}</div>
                                </div>
                            </td>
                            <td>
                                <span
                                    v-for="(st, idx) in getInstanceStatus(instance)"
                                    :key="idx"
                                    :class="['admin-status-badge', 'admin-status-badge--' + st.color, idx ? 'admin-status-badge--stack' : '']"
                                >
                                    <admin-icon v-if="st.icon" :name="st.icon" aria-hidden="true"></admin-icon>
                                    {{ st.label }}
                                </span>
                            </td>
                            <td>
                                <div class="admin-instance-stack">
                                    <div class="admin-instance-stack__primary">{{ instance.plan && instance.plan.name }}</div>
                                    <div v-if="instance.currency || instance.frequency" class="admin-instance-stack__muted">
                                        <template v-if="instance.currency">{{ instance.currency.name }}</template>
                                        <template v-if="instance.currency && instance.frequency"> · </template>
                                        <template v-if="instance.frequency">{{ trans('list.'+instance.frequency) }}</template>
                                    </div>
                                </div>
                            </td>
                            <td class="admin-table-cell--instance-db">
                                <div class="admin-instance-stack">
                                    <code v-if="instanceDatabaseName(instance)" class="admin-instance-stack__mono">{{ instanceDatabaseName(instance) }}</code>
                                    <div v-else class="admin-instance-stack__muted">—</div>
                                    <div v-if="instanceDatabaseId(instance)" class="admin-instance-stack__muted">#{{ instanceDatabaseId(instance) }}</div>
                                </div>
                            </td>
                            <td>{{instance.created_at | moment }}</td>
                            <td class="admin-table-actions-cell">
                                <table-row-action-dropdown>
                                    <b-dropdown-item v-if="hasPermission('list-instance')" :to="'/instance/'+instance.id">
                                        <admin-icon name="eye"></admin-icon> {{ trans('instance.view_instance') }}
                                    </b-dropdown-item>
                                    <b-dropdown-item-button
                                        v-if="hasPermission('list-instance') && (instance.status === 'running' || instance.status === 'trial')"
                                        @click="openSchoolDirectLogin(instance)"
                                    >
                                        <admin-icon name="external-link"></admin-icon> {{ trans('instance.direct_login_school') }}
                                    </b-dropdown-item-button>
                                    <b-dropdown-item-button
                                        v-if="hasPermission('delete-instance')"
                                        v-confirm="{ok: confirmDelete(instance)}"
                                        class="admin-row-actions__danger"
                                    >
                                        <admin-icon name="trash"></admin-icon> {{ trans('general.delete') }}
                                    </b-dropdown-item-button>
                                </table-row-action-dropdown>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="admin-table-pagination-wrap">
                <pagination-record :page-length.sync="filterInstanceForm.page_length" :records="instances" @updateRecords="getInstances" @change.native="getInstances"></pagination-record>
            </div>
        </div>

        <div class="admin-list-table-card admin-empty-state mt-3" v-if="!instances.total" role="status">
            <div class="admin-empty-state__inner">
                <div class="admin-empty-state__icon-wrap" aria-hidden="true">
                    <admin-icon name="database"></admin-icon>
                </div>
                <h4 class="admin-empty-state__title">{{ trans('instance.empty_list_title') }}</h4>
                <p class="admin-empty-state__text">{{ trans('instance.empty_list_hint') }}</p>
                <button
                    v-if="hasPermission('edit-instance')"
                    type="button"
                    class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid mt-2"
                    v-b-modal.modal-instance-create
                >
                    <admin-icon name="plus"></admin-icon> {{ trans('instance.add_new_instance') }}
                </button>
            </div>
        </div>

        <b-modal
            id="modal-instance-create"
            hide-footer
            hide-header
            size="lg"
            centered
            modal-class="admin-modal-pro admin-modal-pro--instance-create"
            content-class="admin-modal-pro__content admin-modal-pro__content--instance-create"
            body-class="p-0"
            @shown="resetInstanceCreateWizard"
        >
            <div class="admin-instance-create-card">
                <button
                    type="button"
                    class="admin-instance-create-card__close close"
                    :aria-label="trans('general.close')"
                    @click="$bvModal.hide('modal-instance-create')"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
                <h2 class="admin-instance-create-card__title">{{ trans('instance.add_new_instance') }}</h2>
                <p v-if="instanceCreateStep === 1" class="admin-instance-create-card__sub">{{ trans('instance.create_modal_subdomain_step') }}</p>
                <p v-else class="admin-instance-create-card__sub">{{ trans('instance.create_modal_details_step') }}</p>

                <form class="admin-instance-create-form" @submit.prevent="submitNewInstance" @keydown="instanceForm.errors.clear($event.target.name)">
                    <template v-if="instanceCreateStep === 1">
                        <div class="admin-instance-create-field">
                            <label class="admin-instance-create-label" for="instance-create-domain">{{ trans('instance.school_subdomain') }} <span class="text-danger">*</span></label>
                            <div
                                class="admin-instance-create-domain-input"
                                id="instance-create-domain-wrap"
                                :class="instanceCreateDomainInputClass"
                            >
                                <input
                                    id="instance-create-domain"
                                    class="admin-instance-create-domain-input__field"
                                    type="text"
                                    autocomplete="off"
                                    v-model="domainDraft"
                                    :placeholder="trans('instance.domain')"
                                    @blur="onDomainInputBlur"
                                >
                                <span class="admin-instance-create-domain-input__suffix" v-text="domainSuffix"></span>
                            </div>
                            <div v-if="domainLiveCheck.loading && normalizedDomainDraft" class="admin-domain-live-status admin-domain-live-status--pending">
                                <span class="admin-domain-live-status__pulse" aria-hidden="true"></span>
                                <span class="admin-domain-live-status__text">{{ instanceTxt('instance.domain_checking', 'Checking availability…') }}</span>
                            </div>
                            <div v-else-if="normalizedDomainDraft && domainResultVariant !== 'none'" class="admin-domain-result-wrap">
                                <div
                                    class="admin-domain-result-banner"
                                    :class="'admin-domain-result-banner--' + domainResultVariant"
                                    role="status"
                                >
                                    <span class="admin-domain-result-banner__headline">{{ domainResultHeadline }}</span>
                                    <p v-if="domainResultDetail" class="admin-domain-result-banner__detail">{{ domainResultDetail }}</p>
                                    <div v-if="domainResultVariant === 'ok'" class="admin-domain-preview">
                                        https://{{ domainLiveCheck.slug }}<span v-text="normalizedListDomainSuffix()"></span>
                                    </div>
                                    <ul v-if="(domainResultVariant === 'invalid' || domainResultVariant === 'error') && domainLiveCheck.validation_errors && domainLiveCheck.validation_errors.length" class="admin-domain-live-errors">
                                        <li v-for="(err, ei) in domainLiveCheck.validation_errors" :key="ei">{{ err }}</li>
                                    </ul>
                                    <div v-if="domainResultVariant === 'taken' && domainLiveCheck.suggestions && domainLiveCheck.suggestions.length" class="admin-domain-suggestions">
                                        <div class="admin-domain-suggestions__label">{{ instanceTxt('instance.domain_try_suggestions', 'Try one of these (click to use):') }}</div>
                                        <div class="admin-domain-suggestions__chips">
                                            <button
                                                v-for="sug in domainLiveCheck.suggestions"
                                                :key="sug"
                                                type="button"
                                                class="admin-domain-suggestion-chip"
                                                @click="applyDomainSuggestion(sug)"
                                            >{{ sug }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="instanceCreateStep === 1 && normalizedDomainDraft && !canContinueInstanceDomainStep" class="admin-domain-step1-actions mt-2">
                                <p class="admin-domain-continue-hint text-soft small mb-0">
                                    {{ instanceTxt('instance.domain_continue_hint', 'Confirm an available address to continue to the next step.') }}
                                </p>
                                <button
                                    v-if="!domainLiveCheck.loading"
                                    type="button"
                                    class="btn btn-sm btn-outline-primary mt-2"
                                    @click="runDomainCheck"
                                >
                                    {{ instanceTxt('instance.domain_check_button', 'Check availability') }}
                                </button>
                            </div>
                        </div>
                        <button
                            v-show="canContinueInstanceDomainStep"
                            type="button"
                            class="admin-instance-create-submit"
                            @click="goToInstanceCreateStep2"
                        >
                            <span>{{ instanceTxt('instance.domain_continue', 'Continue') }}</span>
                            <admin-icon name="arrow-right" aria-hidden="true"></admin-icon>
                        </button>
                    </template>

                    <div v-show="instanceCreateStep === 2" class="admin-instance-create-locked-domain">
                        <div class="admin-instance-create-locked-domain__text">
                            <admin-icon name="link" aria-hidden="true"></admin-icon>
                            <span><strong>{{ instanceForm.domain }}</strong><span v-text="normalizedListDomainSuffix()"></span></span>
                        </div>
                        <button type="button" class="btn btn-sm btn-outline-secondary admin-instance-create-locked-domain__edit" @click="backToInstanceCreateDomainStep">
                            {{ trans('instance.domain_change_subdomain') }}
                        </button>
                    </div>

                    <div v-show="instanceCreateStep === 2" class="admin-instance-create-grid-2">
                        <div class="admin-instance-create-field">
                            <label class="admin-instance-create-label" for="instance-create-fn">{{ trans('user.first_name') }} <span class="text-danger">*</span></label>
                            <input id="instance-create-fn" class="form-control admin-instance-create-control" type="text" name="first_name" v-model="instanceForm.first_name" :placeholder="trans('user.first_name')">
                            <show-error :form-name="instanceForm" prop-name="first_name"></show-error>
                        </div>
                        <div class="admin-instance-create-field">
                            <label class="admin-instance-create-label" for="instance-create-ln">{{ trans('user.last_name') }} <span class="text-danger">*</span></label>
                            <input id="instance-create-ln" class="form-control admin-instance-create-control" type="text" name="last_name" v-model="instanceForm.last_name" :placeholder="trans('user.last_name')">
                            <show-error :form-name="instanceForm" prop-name="last_name"></show-error>
                        </div>
                    </div>

                    <div v-show="instanceCreateStep === 2">
                    <div class="admin-instance-create-field">
                        <label class="admin-instance-create-label" for="instance-create-school">{{ trans('instance.school_name') }} <span class="text-danger">*</span></label>
                        <input id="instance-create-school" class="form-control admin-instance-create-control" type="text" name="school_name" v-model="instanceForm.school_name" :placeholder="trans('instance.school_name')">
                        <show-error :form-name="instanceForm" prop-name="school_name"></show-error>
                    </div>

                    <div class="admin-instance-create-field">
                        <label class="admin-instance-create-label" for="instance-create-email">{{ trans('instance.email') }} <span class="text-danger">*</span></label>
                        <input id="instance-create-email" class="form-control admin-instance-create-control" type="email" name="email" v-model="instanceForm.email" :placeholder="trans('instance.email')">
                        <show-error :form-name="instanceForm" prop-name="email"></show-error>
                    </div>

                    <div class="admin-instance-create-grid-2">
                        <div class="admin-instance-create-field">
                            <label class="admin-instance-create-label" for="instance-create-user">{{ trans('instance.username') }}</label>
                            <input id="instance-create-user" class="form-control admin-instance-create-control" type="text" name="username" v-model="instanceForm.username" :placeholder="trans('instance.username')">
                            <show-error :form-name="instanceForm" prop-name="username"></show-error>
                        </div>
                        <div class="admin-instance-create-field">
                            <label class="admin-instance-create-label" for="instance-create-tz">{{ trans('configuration.timezone') }}</label>
                            <select id="instance-create-tz" class="form-control admin-instance-create-control" name="timezone" v-model="instanceForm.timezone">
                                <option value="">{{ trans('general.select_one') }}</option>
                                <option v-for="tz in createTimezones" :key="tz.value" :value="tz.value">{{ tz.text }}</option>
                            </select>
                            <show-error :form-name="instanceForm" prop-name="timezone"></show-error>
                        </div>
                    </div>

                    <div class="admin-instance-create-grid-2">
                        <div class="admin-instance-create-field">
                            <label class="admin-instance-create-label" for="instance-create-pw">{{ trans('instance.admin_password') }} <span class="text-danger">*</span></label>
                            <input id="instance-create-pw" class="form-control admin-instance-create-control" type="password" name="password" v-model="instanceForm.password" :placeholder="trans('user.password')" autocomplete="new-password">
                            <show-error :form-name="instanceForm" prop-name="password"></show-error>
                        </div>
                        <div class="admin-instance-create-field">
                            <label class="admin-instance-create-label" for="instance-create-pw2">{{ trans('user.password_confirmation') }} <span class="text-danger">*</span></label>
                            <input id="instance-create-pw2" class="form-control admin-instance-create-control" type="password" name="password_confirmation" v-model="instanceForm.password_confirmation" :placeholder="trans('user.password_confirmation')" autocomplete="new-password">
                            <show-error :form-name="instanceForm" prop-name="password_confirmation"></show-error>
                        </div>
                    </div>

                    <div class="admin-instance-create-grid-2">
                        <div class="admin-instance-create-field">
                            <label class="admin-instance-create-label" for="instance-create-phone">{{ trans('instance.phone') }} <span class="text-danger">*</span></label>
                            <input id="instance-create-phone" class="form-control admin-instance-create-control" type="text" name="phone" v-model="instanceForm.phone" :placeholder="trans('instance.phone')">
                            <show-error :form-name="instanceForm" prop-name="phone"></show-error>
                        </div>
                        <div class="admin-instance-create-field">
                            <label class="admin-instance-create-label" for="instance-create-country">{{ trans('user.country') }} <span class="text-danger">*</span></label>
                            <select id="instance-create-country" class="form-control admin-instance-create-control" name="country_id" v-model="instanceForm.country_id">
                                <option value="">{{ trans('general.select_one') }}</option>
                                <option v-for="c in createCountries" :key="c.value" :value="c.value">{{ c.text }}</option>
                            </select>
                            <show-error :form-name="instanceForm" prop-name="country_id"></show-error>
                        </div>
                    </div>

                    <div class="admin-instance-create-grid-2">
                        <div class="admin-instance-create-field">
                            <label class="admin-instance-create-label" for="instance-create-plan">{{ trans('plan.plan') }} <span class="text-danger">*</span></label>
                            <select id="instance-create-plan" class="form-control admin-instance-create-control" name="plan_id" v-model="instanceForm.plan_id">
                                <option value="">{{ trans('general.select_one') }}</option>
                                <option v-for="plan in createPlans" :key="plan.id" :value="plan.id">{{ plan.name }}</option>
                            </select>
                            <show-error :form-name="instanceForm" prop-name="plan_id"></show-error>
                        </div>
                        <div class="admin-instance-create-field">
                            <label class="admin-instance-create-label" for="instance-create-currency">{{ trans('currency.currency') }} <span class="text-danger">*</span></label>
                            <select id="instance-create-currency" class="form-control admin-instance-create-control" name="currency_id" v-model="instanceForm.currency_id">
                                <option value="">{{ trans('general.select_one') }}</option>
                                <option v-for="cur in createCurrencies" :key="cur.id" :value="cur.id">{{ cur.name }}</option>
                            </select>
                            <show-error :form-name="instanceForm" prop-name="currency_id"></show-error>
                        </div>
                    </div>

                    <div class="admin-instance-create-grid-2">
                        <div class="admin-instance-create-field">
                            <label class="admin-instance-create-label" for="instance-create-freq">{{ trans('plan.payment_frequency') }} <span class="text-danger">*</span></label>
                            <select id="instance-create-freq" class="form-control admin-instance-create-control" name="frequency" v-model="instanceForm.frequency">
                                <option value="">{{ trans('general.select_one') }}</option>
                                <option v-for="fr in createFrequencies" :key="fr.id" :value="fr.id">{{ fr.name }}</option>
                            </select>
                            <show-error :form-name="instanceForm" prop-name="frequency"></show-error>
                        </div>
                        <div class="admin-instance-create-field">
                            <label class="admin-instance-create-label" for="instance-create-max">{{ trans('instance.max_student') }}</label>
                            <input id="instance-create-max" class="form-control admin-instance-create-control" type="number" name="max_student" v-model="instanceForm.max_student" min="1" :placeholder="trans('instance.max_student')">
                            <show-error :form-name="instanceForm" prop-name="max_student"></show-error>
                        </div>
                    </div>

                    <div class="admin-instance-create-field">
                        <label class="admin-instance-create-label" for="instance-create-a1">{{ trans('user.address_line_1') }}</label>
                        <input id="instance-create-a1" class="form-control admin-instance-create-control" type="text" name="address_line_1" v-model="instanceForm.address_line_1" :placeholder="trans('user.address_line_1')">
                        <show-error :form-name="instanceForm" prop-name="address_line_1"></show-error>
                    </div>

                    <div class="admin-instance-create-field">
                        <label class="admin-instance-create-label" for="instance-create-a2">{{ trans('user.address_line_2') }}</label>
                        <input id="instance-create-a2" class="form-control admin-instance-create-control" type="text" name="address_line_2" v-model="instanceForm.address_line_2" :placeholder="trans('user.address_line_2')">
                        <show-error :form-name="instanceForm" prop-name="address_line_2"></show-error>
                    </div>

                    <div class="admin-instance-create-grid-2">
                        <div class="admin-instance-create-field">
                            <label class="admin-instance-create-label" for="instance-create-city">{{ trans('user.city') }}</label>
                            <input id="instance-create-city" class="form-control admin-instance-create-control" type="text" name="city" v-model="instanceForm.city" :placeholder="trans('user.city')">
                            <show-error :form-name="instanceForm" prop-name="city"></show-error>
                        </div>
                        <div class="admin-instance-create-field">
                            <label class="admin-instance-create-label" for="instance-create-state">{{ trans('user.state') }}</label>
                            <input id="instance-create-state" class="form-control admin-instance-create-control" type="text" name="state" v-model="instanceForm.state" :placeholder="trans('user.state')">
                            <show-error :form-name="instanceForm" prop-name="state"></show-error>
                        </div>
                    </div>

                    <div class="admin-instance-create-field">
                        <label class="admin-instance-create-label" for="instance-create-zip">{{ trans('user.zipcode') }}</label>
                        <input id="instance-create-zip" class="form-control admin-instance-create-control" type="text" name="zipcode" v-model="instanceForm.zipcode" :placeholder="trans('user.zipcode')">
                        <show-error :form-name="instanceForm" prop-name="zipcode"></show-error>
                    </div>
                    </div>

                    <button v-show="instanceCreateStep === 2" type="submit" class="admin-instance-create-submit">
                        <span>{{ trans('general.add') }}</span>
                        <admin-icon name="arrow-right" aria-hidden="true"></admin-icon>
                    </button>
                </form>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import dateRangePicker from '../../components/date-range-picker'
    import Form from '../../services/form'

    export default {
        components: {dateRangePicker},
        data(){
            return {
                instances: {
                    total: 0,
                    data: []
                },
                filterInstanceForm: {
                    email: '',
                    domain: '',
                    custom_domain: '',
                    status: '',
                    start_date: '',
                    end_date: '',
                    order: 'desc',
                    sort_by: 'created_at',
                    page_length: helper.getConfig('page_length')
                },
                showFilterPanel: false,
                domainSuffix: '.sipinor.com',
                createPlans: [],
                createCurrencies: [],
                createFrequencies: [],
                createCountries: [],
                createTimezones: [],
                instanceForm: new Form({
                    first_name: '',
                    last_name: '',
                    school_name: '',
                    email: '',
                    username: '',
                    password: '',
                    password_confirmation: '',
                    phone: '',
                    domain: '',
                    plan_id: '',
                    currency_id: '',
                    frequency: '',
                    max_student: '',
                    address_line_1: '',
                    address_line_2: '',
                    city: '',
                    state: '',
                    zipcode: '',
                    country_id: '',
                    timezone: 'Asia/Kolkata',
                }),
                instanceCreateStep: 1,
                domainDraft: '',
                domainCheckTimer: null,
                domainCheckSeq: 0,
                domainLiveCheck: {
                    loading: false,
                    checkFailed: false,
                    valid: null,
                    available: null,
                    slug: '',
                    validation_errors: [],
                    suggestions: [],
                },
            };
        },
        computed: {
            normalizedDomainDraft(){
                return (this.domainDraft || '').trim();
            },
            canContinueInstanceDomainStep(){
                const slug = (this.domainDraft || '').trim().toLowerCase();
                if (!slug || this.domainLiveCheck.loading || this.domainLiveCheck.checkFailed) {
                    return false;
                }
                return this.domainLiveCheck.valid === true
                    && this.domainLiveCheck.available === true
                    && (this.domainLiveCheck.slug || '').toLowerCase() === slug;
            },
            instanceCreateDomainInputClass(){
                if (this.instanceCreateStep !== 1 || !this.normalizedDomainDraft || this.domainLiveCheck.loading) {
                    return {};
                }
                if (this.domainLiveCheck.checkFailed) {
                    return { 'admin-instance-create-domain-input--live-bad': true };
                }
                if (this.domainLiveCheck.valid === true && this.domainLiveCheck.available === true) {
                    return { 'admin-instance-create-domain-input--live-ok': true };
                }
                if (this.domainLiveCheck.valid === false
                    || (this.domainLiveCheck.valid === true && this.domainLiveCheck.available === false)) {
                    return { 'admin-instance-create-domain-input--live-bad': true };
                }
                return {};
            },
            domainResultVariant(){
                if (!this.normalizedDomainDraft || this.domainLiveCheck.loading) {
                    return 'none';
                }
                if (this.domainLiveCheck.checkFailed) {
                    return 'error';
                }
                if (this.domainLiveCheck.valid === null) {
                    return 'none';
                }
                if (this.domainLiveCheck.valid === false) {
                    return 'invalid';
                }
                if (this.domainLiveCheck.available === true) {
                    return 'ok';
                }
                return 'taken';
            },
            domainResultHeadline(){
                switch (this.domainResultVariant) {
                    case 'ok':
                        return this.instanceTxt('instance.domain_headline_available', 'Available');
                    case 'taken':
                        return this.instanceTxt('instance.domain_headline_not_available', 'Already taken');
                    case 'invalid':
                        return this.instanceTxt('instance.domain_headline_invalid', 'Invalid');
                    case 'error':
                        return this.instanceTxt('instance.domain_headline_check_error', 'Could not check');
                    default:
                        return '';
                }
            },
            domainResultDetail(){
                switch (this.domainResultVariant) {
                    case 'ok':
                        return this.instanceTxt('instance.domain_available', 'This subdomain is available. You can continue to the next step.');
                    case 'taken':
                        return this.instanceTxt('instance.domain_taken', 'This subdomain is already in use. Choose another name or pick a suggestion below.');
                    case 'invalid':
                        return this.instanceTxt('instance.domain_invalid_hint', 'Use only letters, numbers, dashes and underscores (max 50 characters).');
                    case 'error':
                        return this.instanceTxt('instance.domain_check_failed', 'We could not verify this address. Check your connection and try again.');
                    default:
                        return '';
                }
            },
        },
        watch: {
            domainDraft(){
                if (this.instanceCreateStep !== 1) {
                    return;
                }
                if (this.domainCheckTimer) {
                    clearTimeout(this.domainCheckTimer);
                    this.domainCheckTimer = null;
                }
                const q = (this.domainDraft || '').trim();
                const qLower = q.toLowerCase();
                if (!q) {
                    this.domainLiveCheck = {
                        loading: false,
                        checkFailed: false,
                        valid: null,
                        available: null,
                        slug: '',
                        validation_errors: [],
                        suggestions: [],
                    };
                    return;
                }
                if (qLower !== (this.domainLiveCheck.slug || '').toLowerCase()) {
                    this.domainLiveCheck = {
                        loading: false,
                        checkFailed: false,
                        valid: null,
                        available: null,
                        slug: '',
                        validation_errors: [],
                        suggestions: [],
                    };
                }
                this.domainCheckTimer = setTimeout(() => this.runDomainCheck(), 350);
            },
        },
        mounted(){
            this.getInstances();
            if (helper.hasPermission('edit-instance')) {
                this.fetchCreatePreRequisite();
            }
        },
        methods: {
            resetInstanceCreateWizard(){
                this.instanceCreateStep = 1;
                this.domainDraft = '';
                if (this.domainCheckTimer) {
                    clearTimeout(this.domainCheckTimer);
                    this.domainCheckTimer = null;
                }
                this.domainLiveCheck = {
                    loading: false,
                    checkFailed: false,
                    valid: null,
                    available: null,
                    slug: '',
                    validation_errors: [],
                    suggestions: [],
                };
                this.instanceForm.reset();
            },
            instanceTxt(dotKey, fallback){
                try {
                    const v = typeof window !== 'undefined' && window._get ? window._get(window.i18n, dotKey) : null;
                    if (v !== undefined && v !== null && String(v).trim() !== '') {
                        return String(v);
                    }
                } catch (e) {
                    /* ignore */
                }
                return fallback;
            },
            emptyDomainLiveCheck(extra){
                return Object.assign({
                    loading: false,
                    checkFailed: false,
                    valid: null,
                    available: null,
                    slug: '',
                    validation_errors: [],
                    suggestions: [],
                }, extra || {});
            },
            /**
             * Normalize API payload (flat or nested) and boolean-like values from JSON.
             */
            parseCheckDomainPayload(raw){
                if (!raw || typeof raw !== 'object') {
                    return null;
                }
                let o = raw;
                if (o.data && typeof o.data === 'object' && ('valid' in o.data || 'available' in o.data)) {
                    o = Object.assign({}, o, o.data);
                }
                const isTrue = (v) => v === true || v === 1 || v === '1' || (typeof v === 'string' && v.toLowerCase() === 'true');
                const isFalse = (v) => v === false || v === 0 || v === '0' || (typeof v === 'string' && v.toLowerCase() === 'false');
                let valid = null;
                if (isTrue(o.valid)) {
                    valid = true;
                } else if (isFalse(o.valid)) {
                    valid = false;
                }
                let available = null;
                if (isTrue(o.available)) {
                    available = true;
                } else if (isFalse(o.available)) {
                    available = false;
                }
                const slug = (o.slug !== undefined && o.slug !== null ? String(o.slug) : '').trim().toLowerCase();
                const validation_errors = Array.isArray(o.validation_errors) ? o.validation_errors : [];
                const suggestions = Array.isArray(o.suggestions) ? o.suggestions : [];
                return { valid, available, slug, validation_errors, suggestions };
            },
            applyDomainCheckNetworkError(){
                this.domainLiveCheck = this.emptyDomainLiveCheck({
                    checkFailed: true,
                });
            },
            runDomainCheck(){
                const q = (this.domainDraft || '').trim();
                if (!q) {
                    this.domainLiveCheck = this.emptyDomainLiveCheck();
                    return;
                }
                const requestKey = q.toLowerCase();
                const mySeq = ++this.domainCheckSeq;
                this.domainLiveCheck = this.emptyDomainLiveCheck({
                    loading: true,
                });
                axios.get('/api/instance/check-domain', { params: { domain: q } })
                    .then(response => response.data)
                    .then(data => {
                        if (mySeq !== this.domainCheckSeq) {
                            return;
                        }
                        const currentKey = (this.domainDraft || '').trim().toLowerCase();
                        if (currentKey !== requestKey) {
                            return;
                        }
                        const parsed = this.parseCheckDomainPayload(data);
                        if (!parsed || parsed.valid === null || parsed.available === null) {
                            this.applyDomainCheckNetworkError();
                            toastr.error(this.trans('instance.domain_check_failed'));
                            return;
                        }
                        if (parsed.slug.toLowerCase() !== requestKey) {
                            this.applyDomainCheckNetworkError();
                            toastr.error(this.trans('instance.domain_check_failed'));
                            return;
                        }
                        this.domainLiveCheck = this.emptyDomainLiveCheck({
                            valid: parsed.valid,
                            available: parsed.available,
                            slug: parsed.slug,
                            validation_errors: parsed.validation_errors,
                            suggestions: parsed.suggestions,
                        });
                    })
                    .catch(() => {
                        if (mySeq !== this.domainCheckSeq) {
                            return;
                        }
                        const currentKey = (this.domainDraft || '').trim().toLowerCase();
                        if (currentKey !== requestKey) {
                            return;
                        }
                        this.applyDomainCheckNetworkError();
                        toastr.error(this.trans('instance.domain_check_failed'));
                    });
            },
            applyDomainSuggestion(sug){
                this.domainDraft = sug;
                if (this.domainCheckTimer) {
                    clearTimeout(this.domainCheckTimer);
                    this.domainCheckTimer = null;
                }
                this.runDomainCheck();
            },
            goToInstanceCreateStep2(){
                if (!this.canContinueInstanceDomainStep) {
                    return;
                }
                this.instanceForm.domain = this.domainLiveCheck.slug;
                this.instanceCreateStep = 2;
            },
            backToInstanceCreateDomainStep(){
                this.instanceCreateStep = 1;
                this.domainDraft = this.instanceForm.domain || '';
                this.$nextTick(() => this.runDomainCheck());
            },
            onDomainInputBlur(){
                if (this.instanceCreateStep !== 1 || !this.normalizedDomainDraft || this.domainLiveCheck.loading) {
                    return;
                }
                if (!this.canContinueInstanceDomainStep && (this.domainLiveCheck.valid === null || this.domainLiveCheck.slug !== this.normalizedDomainDraft.toLowerCase())) {
                    this.runDomainCheck();
                }
            },
            fetchCreatePreRequisite(){
                axios.get('/api/instance/pre-requisite')
                    .then(response => response.data)
                    .then(response => {
                        this.createPlans = response.plans || [];
                        this.createCurrencies = response.currencies || [];
                        this.createFrequencies = response.payment_frequencies || [];
                        this.createCountries = response.countries || [];
                        this.createTimezones = response.timezones || [];
                        if (response.domain_suffix) {
                            this.domainSuffix = response.domain_suffix;
                        }
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            submitNewInstance(){
                const loader = this.$loading.show();
                this.instanceForm.post('/api/instance')
                    .then(response => {
                        if (response.provisioned === false && response.provision_error) {
                            toastr.warning(response.message);
                        } else {
                            toastr.success(response.message);
                        }
                        this.$bvModal.hide('modal-instance-create');
                        if (response.instance && response.instance.id) {
                            this.$router.push('/instance/' + response.instance.id);
                        } else {
                            this.getInstances();
                        }
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    })
                    .finally(() => {
                        loader.hide();
                    });
            },
            getInstances(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterInstanceForm);
                axios.get('/api/instance?page=' + page + url)
                    .then(response => response.data)
                    .then(response => {
                        this.instances = response;
                        if (response.domain_suffix) {
                            this.domainSuffix = response.domain_suffix;
                        }
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            sortList(field){
                if (this.filterInstanceForm.sort_by === field) {
                    this.filterInstanceForm.order = this.filterInstanceForm.order === 'asc' ? 'desc' : 'asc';
                } else {
                    this.filterInstanceForm.sort_by = field;
                    this.filterInstanceForm.order = 'asc';
                }
            },
            getInstanceStatus(instance){
                return helper.getInstanceStatus(instance);
            },
            instanceClientName(instance){
                const fromApi = (instance.client_name || instance.name || '').trim();
                if (fromApi) {
                    return fromApi;
                }
                return ((instance.first_name || '') + ' ' + (instance.last_name || '')).trim();
            },
            instanceSchoolName(instance){
                return (instance.school_name || instance.institute_name || '').trim();
            },
            instanceClientPrimary(instance){
                return this.instanceClientName(instance) || this.instanceSchoolName(instance) || (instance.email || '').trim();
            },
            instanceClientSchoolLine(instance){
                const school = this.instanceSchoolName(instance);
                if (!school || school === this.instanceClientPrimary(instance)) {
                    return '';
                }
                return school;
            },
            instanceCustomDomainLabel(instance){
                const custom = (instance.custom_domain || '').trim();
                if (!custom) {
                    return '';
                }
                const host = custom.replace(/^https?:\/\//i, '').replace(/\/+$/, '');
                const shown = this.instanceDomainDisplayLabel(instance);
                if (host && shown && host.toLowerCase() === shown.toLowerCase()) {
                    return '';
                }
                return host || custom;
            },
            instanceDatabaseName(instance){
                if (instance.database_name) {
                    return instance.database_name;
                }
                if (instance.database && instance.database.database_name) {
                    return instance.database.database_name;
                }
                return '';
            },
            instanceDatabaseId(instance){
                if (instance.database_id != null && instance.database_id !== '') {
                    return instance.database_id;
                }
                if (instance.db_id != null && instance.db_id !== '') {
                    return instance.db_id;
                }
                if (instance.database && instance.database.id) {
                    return instance.database.id;
                }
                return '';
            },
            normalizedListDomainSuffix(){
                const s = (this.domainSuffix || '').trim();
                if (!s) {
                    return '.sipinor.com';
                }
                return s.startsWith('.') ? s : ('.' + s);
            },
            instanceDefaultDomain(instance){
                const slug = (instance.domain || '').trim();
                if (!slug) {
                    return '';
                }
                return slug + this.normalizedListDomainSuffix();
            },
            /** Host-style label for Domain column (subdomain host, or stripped custom domain). */
            instanceDomainDisplayLabel(instance){
                const def = this.instanceDefaultDomain(instance);
                if (def) {
                    return def;
                }
                const custom = (instance.custom_domain || '').trim();
                if (!custom) {
                    return '';
                }
                return custom.replace(/^https?:\/\//i, '').replace(/\/+$/, '');
            },
            instanceDefaultDomainUrl(instance){
                const slug = (instance.domain || '').trim();
                if (!slug) {
                    return '';
                }
                return 'https://' + slug + this.normalizedListDomainSuffix();
            },
            /** Full portal URL (custom domain if set, else default subdomain). */
            instanceSchoolPortalUrl(instance){
                const custom = (instance.custom_domain || '').trim();
                if (custom) {
                    if (/^https?:\/\//i.test(custom)) {
                        return custom.replace(/\/+$/, '');
                    }
                    return 'https://' + custom.replace(/^\/+/, '').replace(/\/+$/, '');
                }
                return this.instanceDefaultDomainUrl(instance);
            },
            canInstanceDirectLogin(instance){
                return this.hasPermission('list-instance')
                    && (instance.status === 'running' || instance.status === 'trial');
            },
            copySchoolPortalUrl(instance){
                const url = this.instanceSchoolPortalUrl(instance);
                if (!url) {
                    return;
                }
                const done = () => { toastr.success(this.trans('instance.school_url_copied')); };
                const fail = () => { toastr.error(this.trans('instance.copy_failed')); };
                if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
                    navigator.clipboard.writeText(url).then(done).catch(() => this.fallbackCopyText(url, done, fail));
                } else {
                    this.fallbackCopyText(url, done, fail);
                }
            },
            fallbackCopyText(text, onSuccess, onFail){
                const ta = document.createElement('textarea');
                ta.value = text;
                ta.setAttribute('readonly', '');
                ta.style.position = 'fixed';
                ta.style.left = '-9999px';
                document.body.appendChild(ta);
                ta.select();
                try {
                    if (document.execCommand('copy')) {
                        onSuccess();
                    } else {
                        onFail();
                    }
                } catch (e) {
                    onFail();
                }
                document.body.removeChild(ta);
            },
            confirmDelete(instance){
                return dialog => this.deleteInstance(instance);
            },
            deleteInstance(instance){
                axios.delete('/api/instance/'+instance.id)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getInstances();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            hasPermission(permission){
                return helper.hasPermission(permission);
            },
            openSchoolDirectLogin(instance){
                const loader = this.$loading.show();
                axios.get('/api/instance/' + instance.id + '/direct-login-url')
                    .then(response => response.data)
                    .then(response => {
                        const url = response.url;
                        if (url) {
                            window.open(url, '_blank', 'noopener');
                        } else {
                            toastr.error(this.trans('instance.direct_login_failed'));
                        }
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    })
                    .finally(() => {
                        loader.hide();
                    });
            }
        },
        filters: {
          moment(date) {
            return helper.formatDateTime(date);
          }
        },
        watch: {
            filterInstanceForm: {
                handler(val){
                    this.getInstances();
                },
                deep: true
            }
        }
    }
</script>
